import React, { useState } from "react"
import bgImage from "../../../assets/Images/landingPage/loginBg.png"
import HeroImg from "../../../assets/Images/landingPage/loginHeroImg.png"
import { Button } from "../../../components/Buttons"
import OTPSection from "./OTPSection"
import PhoneNumberSection from "./PhoneNumberSection"
import { useDispatch } from "react-redux"
import { setUserData } from "../../../redux/userSlice"

const SignUpSection = ({toggleSignUpLoginModal}) => {
  const [phoneNumber, setPhoneNumber] = useState("")
  const [otp, setOtp] = useState("")
  const [otpSent, setOtpSent] = useState(false)
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false)
  const dispatch = useDispatch()
  const handleChange = (e) => {
    const value = e.target.value
    if (!isNaN(value) && value.length <= 10) {
      setPhoneNumber(value)
    }
  }

  const handleOtpChange = (otp) => {
    console.log(otp)
    setOtp(otp)
  }

  const handleSubmit = () => {
    if (otp.length === 4) {
      dispatch(
        setUserData({
          phoneNumber,
          isOtpVerified: true,
          openLoginModal: false,
          openSignupModal: false,
          openKYCModal: true,
        })
      )
    } else if (phoneNumber.length === 10) {
      setOtpSent(true)
    }
  }
  return (
    <div
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
        objectFit: "contain",
      }}
      className="bg-[length:400px_400px] flex justify-center "
    >
      <div className="flex flex-col items-center">
        <img src={HeroImg} alt="bgImage" className="max-h-[333px]"/>
        <p className="font-filson-soft font-[700] text-[32px]">
          Hi, Welcome to FastFin
        </p>

        <div className="flexCol justify-center items-center  w-[80%]">
          <PhoneNumberSection
            value={phoneNumber}
            onChange={handleChange}
            visible={!otpSent}
            isCheckBoxChecked={isCheckboxChecked}
            toggleSignUpLoginModal={toggleSignUpLoginModal}
            onClick={() => setIsCheckboxChecked(!isCheckboxChecked)}
          />
          <OTPSection
            onChange={handleOtpChange}
            otp={otp}
            onClick={() => alert("hi")}
            onClickEdit={() => setOtpSent(false)}
            visible={otpSent}
            phoneNumber={phoneNumber}
          />
          
          <Button
            variant="primary"
            title="Continue"
            className="mt-[33px] "
            disabled={
              otpSent
                ? otp.length < 4
                : !(isCheckboxChecked && phoneNumber?.length == 10)
            }
            onClick={() => {
              handleSubmit()
            }}
          />
          
        </div>
        {!otpSent ? <p className="text-center mt-[20px] font-[400] text-[14px] text-[#424952D9]">
            Already on Fastfin?{" "}
            <span
              className="font-Apparat font-[400] text-[14px] underline text-[#04B085] cursor-pointer"
              onClick={() => toggleSignUpLoginModal()}
            >
              Sign In
            </span>
          </p> : null}
      </div>
    </div>
  )
}

export default SignUpSection
